import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { generateAcceptString } from '@/utils/attachment'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'

@Component({
    mixins: [AttachmentMixin],
})
export default class DropZone extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop({ required: true }) requirments!: Record<string, any>
    @Prop({ default: false }) anonymousToken!: boolean

    get allowedFileTypes() {
        return this.requirments?.allowedExtensions
            ? generateAcceptString(this.requirments.allowedExtensions)
            : []
    }

    get maxBytes() {
        return this.requirments.maxBytes
    }

    dragover(event: any) {
        event.preventDefault()
    }

    async drop(event: any) {
        event.preventDefault()
        await this.uploadFile(event.dataTransfer.files)
    }

    files: any = null
    loading = false
    errorFileTypes: string[] = []

    async uploadFile(data: any) {
        if (data) {
            this.loading = true
            this.$emit('loadingAttachment', true)

            for (let index = 0; index < data.length; index++) {
                if (!this.allowedFileTypes.includes(data[index].type)) {
                    this.errorFileTypes.push(data[index].type)
                    continue
                }
                let newFile = {
                    links: {
                        download: URL.createObjectURL(data[index]),
                    },
                    attributes: {
                        description: null,
                        filename: data[index].name.toLowerCase(),
                        fileId: null,
                    },
                }

                let res = await this.postFile(data[index], false, this.anonymousToken).catch(() => {
                    this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
                })
                if (res) {
                    newFile.attributes.fileId = res
                    this.$emit('passFiles', newFile)
                }
            }

            if (this.errorFileTypes.length > 0) {
                this.$store.commit('setErrorSnackBar', {
                    title: this.$t("fe_common_errors['file_upload.unsupported_filetype.title']"),
                    subtitle: this.$t("fe_common_errors['file_upload.unsupported_filetype.text']", {
                        filetypes: this.lodash.uniq(this.errorFileTypes).join(', '),
                    }),
                })
            }
            this.loading = false
            this.$emit('loadingAttachment', false)
        }
    }
}
